import { Button } from "@mantine/core";
import { IconArrowLeft, IconHome, IconLock } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { ErrorState } from "./ErrorState";

/** Trang thông báo không có quyền truy cập (403). */
const PagePersion = () => {
  const navigate = useNavigate();
  return (
    <ErrorState
      code={403}
      color="orange"
      icon={<IconLock size={52} />}
      title="Bạn không có quyền truy cập"
      description="Tài khoản của bạn chưa được cấp quyền vào trang này. Vui lòng liên hệ quản trị viên nếu bạn cho rằng đây là nhầm lẫn."
      actions={
        <>
          <Button
            leftSection={<IconArrowLeft size={16} />}
            variant="default"
            onClick={() => navigate(-1)}
          >
            Quay lại
          </Button>
          <Button
            leftSection={<IconHome size={16} />}
            onClick={() => navigate("/dashboard")}
          >
            Về trang chủ
          </Button>
        </>
      }
    />
  );
};

export default PagePersion;
